import React, { Component } from "react";
import { Button, Col, Row, Card, Table, Form } from "react-bootstrap";
import configData from "../config.json";
import { toast } from "react-toastify";
export default class ZunoAddons extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sId: sessionStorage.getItem("sessionId"),
      uId: sessionStorage.getItem("uId"),
      //   chpiId: sessionStorage.getItem("chpiId"),
      //   proposalId: sessionStorage.getItem("proposalId"),
      //   baseproductId: sessionStorage.getItem("baseproductId"),
      //   cqrId: sessionStorage.getItem("cqrId"),
      chpiId: 3290,
      proposalId: sessionStorage.getItem("proposalId"),
      policyuuid: sessionStorage.getItem("policyId"),
      policyType: sessionStorage.getItem("selectedPlanName"),
      policyinsurancemember: sessionStorage.getItem("insuredMembers"),
      planrequestId: sessionStorage.getItem("planrequestId"),
      baseproductId: "Supremo",
      cqrId: 5529,
      updatepremium: "",
      addons: [],
      policiesTable: [],
      mandatoryaddons: [],
      optionaladdons: [],
      defalutaddons: [],
      showExistingSince: {},
      isSameAsPermanent: false,
      dateValues: {},
      checkboxmonth: {},
      isButtonDisabled: false,
      isProposalDisabled: true,
    };
    this.proposalTimer = null;
  }
  showToast = (msg, type) => {
    var tType = toast.TYPE.INFO;
    if (type === "success") tType = toast.TYPE.SUCCESS;
    if (type === "error") tType = toast.TYPE.ERROR;
    if (type === "warning") tType = toast.TYPE.WARNING;
    toast(msg, { type: tType });
  };
  handleSubmitClick = (e) => {
    window.location.href = "/zunoproposerinfo";
  };
  componentDidMount() {
    this.apisfetchHandler();
    this.CaresupremeaddonsfetchHandler();
    this.loadInitialPremium();
  }
  componentWillUnmount() {
    if (this.proposalTimer) clearTimeout(this.proposalTimer);
  }
  //load premium
  loadInitialPremium = () => {
    try {
      const policyData = JSON.parse(sessionStorage.getItem("policyData"));
      const selectedPlanName = sessionStorage.getItem("selectedPlanName");

      if (policyData && selectedPlanName) {
        const selectedPlan = policyData?.applicablePlans?.[selectedPlanName];
        if (selectedPlan && selectedPlan.premiumDetails) {
          this.setState({
            updatepremium: selectedPlan.premiumDetails.totalPremium || 0,
          });
        }
      }
    } catch (error) {
      console.error("Error loading initial premium:", error);
    }
  };
  apisfetchHandler = () => {
    var formData = new FormData();
    formData.append("proposalId", this.state.proposalId);
    formData.append("baseproductId", this.state.baseproductId);
    fetch(configData.api_url + "rg_Leads/getleaddetails/", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.success);
        if (data.status === "success") {
          this.setState({
            members: data.lead.members,
            tenure: data.lead.tenure,
          });
          //this.CaresupremeaddonsfetchHandler();
        }
      });
  };
  CaresupremeaddonsfetchHandler = () => {
    var formData = new FormData();
    formData.append("chpiId", this.state.chpiId);
    formData.append("baseproductId", this.state.baseproductId);
    fetch(configData.api_url + "rg_Leads/getproductdetails", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({ mandatoryaddons: data.product.mandatory_addons });
          this.setState({ optionaladdons: data.product.optional_addons });
          //this.setState({ addons: data.product.optional_addons });
          this.getDefalutAddOns();
        }
      });
    // formData.append("chpiId", this.state.chpiId);
    // formData.append("baseproductId", this.state.baseproductId);
    // fetch(configData.api_url + "C_Caresupremeaddons/list", {
    //   method: "POST",
    //   mode: "cors",
    //   body: formData,
    // })
    //   .then((response) => response.json())
    //   .then((data) => {
    //     if (data.status === "success") {
    //       const supremoOnly = data.list.filter(
    //         (item) => item.productName === "Supremo"
    //       );
    //       //this.setState({ mandatoryaddons: data.list });
    //       this.setState({ optionaladdons: supremoOnly });
    //       //this.setState({ addons: data.product.optional_addons });
    //       this.getDefalutAddOns();
    //     }
    //   });
  };

  getDefalutAddOns = () => {
    var formData = new FormData();
    formData.append("chpiId", this.state.chpiId);
    formData.append("proposalId", this.state.proposalId);
    formData.append("baseproductId", this.state.baseproductId);
    fetch(configData.api_url + "zuno_Leads/getdefaultAddons", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({ defalutaddons: data.defalutaddons });
          //var disabledAddons = [];
          var optionaladdons = this.state.optionaladdons;
          var defalutaddons = this.state.defalutaddons;
          optionaladdons.forEach((quote) => {
            quote.isDefault = "no";
            quote.isdisable = "yes";
            quote.isMandatory = "no";
            if (defalutaddons.includes(quote.addONCode)) {
              // quote.isMandatory = "yes";
              // quote.isDefault = "yes";
              quote.isdisable = "no";
              //disabledAddons = quote.disabledAddons.split(",");
            }
          });
          this.setState({ optionaladdons: optionaladdons });
          // this.setState((prevState) => {
          //   const updatedAddonsData = prevState.optionaladdons.map((quote) => {
          //     var isdisable = "no";
          //     if (
          //       disabledAddons.includes(quote.addONCode) ||
          //       defalutaddons.includes(quote.addONCode)
          //     ) {
          //       isdisable = "yes";
          //     }
          //     return { ...quote, isdisable: isdisable };
          //   });
          //   return { optionaladdons: updatedAddonsData };
          // });
        }
      });
  };

  handleInputChange = (tab, field, value) => {
    this.setState((prevState) => ({
      [tab]: {
        ...prevState[tab],
        [field]: value,
      },
    }));
  };
  handleSubmitBackClick = (e) => {
    window.location.href = "/policyformpage";
  };
  handleAddonsCheckboxChange = (
    addONCode,
    caresupremeaddons_Id,
    isChecked,
    selectedValue
  ) => {
    this.setState((prevState) => {
      const updatedAddonsData = prevState.mandatoryaddons.map((quote) => {
        if (quote.addONCode === addONCode) {
          return {
            ...quote,
            isMandatory: isChecked ? "yes" : "no",
          };
        }
        return quote;
      });
      return { mandatoryaddons: updatedAddonsData };
    });
  };
  handleAddonsSelectChange = (
    addONCode,
    caresupremeaddons_Id,
    selectedValue
  ) => {
    this.setState((prevState) => {
      const updatedAddonsData = prevState.mandatoryaddons.map((quote) => {
        if (quote.addONCode === addONCode) {
          return {
            ...quote,
            ans: selectedValue || "",
          };
        }
        return quote;
      });
      return { mandatoryaddons: updatedAddonsData };
    });
  };
  handleOptionalCheckboxChange = (
    addONCode,
    caresupremeaddons_Id,
    isChecked,
    selectedValue
  ) => {
    this.setState((prevState) => {
      const updatedAddonsData = prevState.optionaladdons.map((quote) => {
        if (quote.addONCode === addONCode) {
          return {
            ...quote,
            isMandatory: isChecked ? "yes" : "no",
          };
        }
        return quote;
      });
      return { optionaladdons: updatedAddonsData, selectedValue };
    });
  };
  // handleOptionalSelectChange = (
  //   addONCode,
  //   caresupremeaddons_Id,
  //   selectedValue
  // ) => {
  //   this.setState((prevState) => {
  //     const updatedAddonsData = prevState.optionaladdons.map((quote) => {
  //       if (quote.caresupremeaddons_Id === caresupremeaddons_Id) {
  //         return {
  //           ...quote,
  //           isMandatory: "yes", // Mark selected
  //           selectedValue: selectedValue,
  //         };
  //       }
  //       return quote;
  //     });
  //     return { optionaladdons: updatedAddonsData };
  //   });
  //   console.log(selectedValue);
  // };
  handleOptionalSelectChange = (addonCode, addonId, selectedValue) => {
    const updatedOptionalAddons = this.state.optionaladdons.map((addon) => {
      if (
        addon.addONCode === addonCode &&
        addon.caresupremeaddons_Id === addonId
      ) {
        return {
          ...addon,
          selectedValue, // ✅ update this field properly
        };
      }
      return addon;
    });
    this.setState({ optionaladdons: updatedOptionalAddons }, () => {});
  };

  handleComplete = () => {
    const { proposalId, baseproductId } = this.state;
    const rawAddons = [
      ...this.state.mandatoryaddons,
      ...this.state.optionaladdons,
    ];
    const dummyIndex = rawAddons.findIndex(
      (a) => a.addONCode === "selectedValue" && a.addOn === "Voluntary Co-pay"
    );
    const volDummy =
      dummyIndex > -1 ? rawAddons.splice(dummyIndex, 1)[0] : null;
    const allAddons = rawAddons.map((addon) => {
      if (addon.addONCode === "Voluntary Co-pay" && volDummy) {
        return {
          // keep all original fields...
          ...addon,
          // but override dummyTwo & selectedValue from that dummy entry
          dummyTwo: volDummy.dummyTwo,
          selectedValue: volDummy.selectedValue,
        };
      }
      return addon;
    });
    const subCoverages = {};
    allAddons.forEach((addon) => {
      const addonCode = addon.addONCode;

      // Skip invalid addon entries like { addONCode: "selectedValue" }
      if (
        !addonCode ||
        typeof addonCode !== "string" ||
        addonCode === "selectedValue"
      ) {
        return;
      }

      const isSelected =
        addon.isMandatory === true || addon.isMandatory === "yes";

      if (addonCode === "Voluntary Co-pay") {
        const selectedVal = addon.selectedValue ?? null;
        subCoverages[addonCode] = {
          isSelected: isSelected,
          isOptionsActive: isSelected,
          coverPercentage: {
            selectedValue: isSelected ? selectedVal : null,
          },
        };
      } else {
        subCoverages[addonCode] = {
          isSelected: isSelected,
        };
      }
    });
    const formData = new FormData();
    formData.append("proposalId", proposalId);
    formData.append("baseproductId", baseproductId);
    formData.append("subCoverages", JSON.stringify(subCoverages)); // <- main change

    fetch(configData.api_url + "rg_Leads/updateleadaddons1/", {
      method: "POST",
      headers: {},
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          //this.updateQuote();
        }
      });
  };
  handleSubmitnextClick = (e) => {
    this.setState({ updatepremium: "" });
    const policyData = JSON.parse(sessionStorage.getItem("policyData")) || {};
    const selectedPlanName =
      sessionStorage.getItem("selectedPlanName") || "Prime";
    const originalSubCoverages =
      policyData?.applicablePlans?.[selectedPlanName]?.subCoverages || {};
    const insuredMembers =
      JSON.parse(sessionStorage.getItem("insuredMembers")) || [];
    const correspondingInsuredMember = insuredMembers[0] || {};
    // Filter insuredMembers to only include required fields
    const filteredInsuredMembers = insuredMembers.map((member) => ({
      memberId: member.memberId,
      dob: member.dob,
      type: member.type,
      isEdelweissEmployee: member.isEdelweissEmployee,
      isEdelweissCustomer: member.isEdelweissCustomer,
      isDeleted: member.isDeleted,
      income: member.income,
      customerNumber: member.customerNumber || null,
      employeeNumber: member.employeeNumber || null,
      PACoverAmount: correspondingInsuredMember.PACoverAmount,
    }));
    // Step 2: Create subCoverages from mandatory and optional addons
    const rawAddons = [
      ...this.state.mandatoryaddons,
      ...this.state.optionaladdons,
    ];
    const dummyIndex = rawAddons.findIndex(
      (a) => a.addONCode === "selectedValue" && a.addOn === "Voluntary Co-pay"
    );
    const volDummy =
      dummyIndex > -1 ? rawAddons.splice(dummyIndex, 1)[0] : null;
    const allAddons = rawAddons.map((addon) => {
      if (addon.addONCode === "Voluntary Co-pay" && volDummy) {
        return {
          // keep all original fields...
          ...addon,
          // but override dummyTwo & selectedValue from that dummy entry
          dummyTwo: volDummy.dummyTwo,
          selectedValue: volDummy.selectedValue,
        };
      }
      return addon;
    });
    const subCoverages = {};
    allAddons.forEach((addon) => {
      const addonCode = addon.addONCode;

      // Skip invalid addon entries like { addONCode: "selectedValue" }
      if (
        !addonCode ||
        typeof addonCode !== "string" ||
        addonCode === "selectedValue"
      ) {
        return;
      }

      const isSelected =
        addon.isMandatory === true || addon.isMandatory === "yes";

      if (addonCode === "Voluntary Co-pay") {
        const selectedVal = addon.selectedValue ?? null;
        subCoverages[addonCode] = {
          isSelected: isSelected,
          isOptionsActive: isSelected,
          coverPercentage: {
            selectedValue: isSelected ? selectedVal : null,
          },
        };
      } else {
        subCoverages[addonCode] = {
          isSelected: isSelected,
        };
      }
    });
    const updatedSubCoverages = { ...originalSubCoverages }; // clone first

    // Step 3: Replace only the specific 4 keys if present
    allAddons.forEach((addon) => {
      const addonCode = addon.addONCode;
      if (
        !addonCode ||
        typeof addonCode !== "string" ||
        addonCode === "selectedValue"
      ) {
        return;
      }

      const isSelected =
        addon.isMandatory === true || addon.isMandatory === "yes";

      // Only override these 4 optional coverages
      if (
        [
          "Worldwide Cover",
          "PED Waiting Period Reduction",
          "Out Patient Consultation",
          "Voluntary Co-pay",
        ].includes(addonCode)
      ) {
        if (addonCode === "Voluntary Co-pay") {
          const selectedVal = addon.selectedValue ?? null;
          updatedSubCoverages[addonCode] = {
            isSelected: isSelected,
            isOptionsActive: isSelected,
            coverPercentage: {
              selectedValue: isSelected ? selectedVal : null,
            },
          };
        } else {
          updatedSubCoverages[addonCode] = {
            isSelected: isSelected,
          };
        }
      }
    });
    const proposerDetails = {
      plan: this.state.policyType,
      sumInsured: parseInt(correspondingInsuredMember.PACoverAmount) || 0,
      // policyTerm: String(policyData?.contractDetails?.[0]?.policyTerm || ""),
      policyTerm: String(this.state.tenure || ""),
      subCoverages: updatedSubCoverages,
      discounts: {},
      insuredMembers: filteredInsuredMembers,
    };
    const jsonData = {
      sourceId: "6128058a-3ff6-4e38-b712-9ed1b8d1d52e",
      policyId: this.state.policyuuid,
      policyCase: "fresh",
      policyType: policyData.policyType,
      contractDetails: [proposerDetails],
    };
    const jsonData1 = JSON.stringify(jsonData);
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("integId", 369);
    formData.append("savedata", "yes");
    formData.append("jsonData", JSON.stringify(jsonData1));
    //formData.append("jsonData", this.state.jsonData);
    fetch(configData.api_url + "C_Integrationlibrary/saveJson", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.setState({ isSuccess: true });
          sessionStorage.setItem("planrequestId", data.requestId);
          setTimeout(() => {
            this.ResponsejsonfetchHandler();
          }, 15000);
          // this.setState({ isProposalDisabled: true }, () => {
          //   if (this.proposalTimer) clearTimeout(this.proposalTimer);
          //   this.proposalTimer = setTimeout(() => {
          //     this.setState({ isProposalDisabled: false });
          //     this.proposalTimer = null;
          //   }, 50_000);
          // });
          //
        }
      });
  };
  ResponsejsonfetchHandler = () => {
    const sessionRequestId = sessionStorage.getItem("planrequestId");
    const selectedPlanName = sessionStorage.getItem("selectedPlanName");

    // Add validation
    if (!sessionRequestId) {
      this.showToast("Session data missing", "error");
      return;
    }
    if (!selectedPlanName) {
      this.showToast("Plan selection data missing", "error");
      return;
    }

    const formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("integId", 369);
    formData.append("requestId", sessionRequestId);

    fetch(
      configData.api_url + "C_Integrationlibrary/retriveResJsonByRequestId",
      {
        method: "POST",
        mode: "cors",
        body: formData,
      }
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          // Store the quotes data
          this.setState({
            quotesss: data.data,
          });

          // Extract premium details more safely
          const policyData = data.data?.data?.policyData;
          if (!policyData) {
            return;
          }

          const plans = policyData.applicablePlans || {};
          const selectedPlan = plans[selectedPlanName];
          if (!selectedPlan) {
            this.showToast(`Plan '${selectedPlanName}' not available`, "error");
            return;
          }
          const premiumDetails = selectedPlan.premiumDetails || {};
          const totalPremium = premiumDetails.totalPremium || 0;

          // Update state with the premium
          this.setState(
            {
              updatepremium: totalPremium,
            },
            () => {}
          );
        } else {
          this.showToast("Failed to load premium details", "error");
          this.loadInitialPremium();
        }
      })
      .catch((err) => {
        this.showToast("Unable to load premium details", "error");
        this.loadInitialPremium();
      });
  };
  // handleComplete = () => {
  //   const selectedAddons = [
  //     ...this.state.mandatoryaddons,
  //     ...this.state.optionaladdons,
  //   ];
  //   const selectedAddonsList = selectedAddons.map((quote) => ({
  //     aoId: quote.caresupremeaddons_Id,
  //     aoCode: quote.addONCode,
  //     isSelected: quote.isMandatory,
  //   }));
  //   const formData = new FormData();
  //   formData.append("proposalId", this.state.proposalId);
  //   formData.append("baseproductId", this.state.baseproductId);
  //   formData.append("addons", JSON.stringify(selectedAddonsList));
  //   fetch(configData.api_url + "zuno_Leads/updateleadaddons1/", {
  //     method: "POST",
  //     headers: {},
  //     mode: "cors",
  //     body: formData,
  //   })
  //     .then((response) => response.json())
  //     .then((data) => {
  //       this.showToast(data.message, data.status);
  //       if (data.status === "success") {
  //         this.updateQuote();
  //       }
  //     });
  // };

  handleSubmitnextoneClick = (e) => {
    const currentPremium = this.state.updatepremium || 0;
    sessionStorage.setItem("currentPremium", currentPremium.toString());
    sessionStorage.setItem(
      "premiumDisplayValue",
      currentPremium.toLocaleString("en-IN")
    );
    window.location.href = "/zunoproposerinfo";
  };
  render() {
    return (
      <div>
        <h1>ZunoAddons</h1>
        <Row id="MainRoOne">
          <Col>
            <Row>
              <Col xs={10} md={10} lg={8}>
                <Card id="firstCarOne">
                  <Row id="firstRoTwo">
                    <Col id="firstColTh3">
                      <span
                        className="bi bi-person-fill"
                        id="activeIcon"
                      ></span>
                    </Col>
                  </Row>
                  <Row>
                    <div>
                      <h6 style={{ color: "#3d5a95" }}>Addon's</h6>
                    </div>
                  </Row>
                </Card>
              </Col>
              <Col xs={2} md={2} lg={2}>
                <span
                  className="bi bi-arrow-right"
                  id="activeTitileArrow"
                ></span>
              </Col>
            </Row>
          </Col>
          <Col>
            <Row>
              <Col xs={10} md={10} lg={8}>
                <Card id="firstCarOne">
                  <Row id="firstRoTwo">
                    <Col id="inActiveTab">
                      <span
                        className="bi bi-person-fill"
                        id="activeIcon"
                      ></span>
                    </Col>
                  </Row>
                  <Row>
                    <div>
                      <h6 style={{ color: "#3d5a95" }}>Proposer Info</h6>
                    </div>
                  </Row>
                </Card>
              </Col>
              <Col xs={2} md={2} lg={2}>
                <span
                  className="bi bi-arrow-right"
                  id="activeTitileArrow"
                ></span>
              </Col>
            </Row>
          </Col>
          <Col>
            <Row>
              <Col xs={10} md={10} lg={8}>
                <Card id="firstCarOne">
                  <Row id="firstRoTwo">
                    <Col id="inActiveTab">
                      <span
                        className="bi bi-person-vcard-fill"
                        id="activeIcon"
                      ></span>
                    </Col>
                  </Row>
                  <Row>
                    <div>
                      <h6 style={{ color: "#3d5a95" }}>Member Info</h6>
                    </div>
                  </Row>
                </Card>
              </Col>
              <Col xs={2} md={2} lg={2}>
                <span
                  className="bi bi-arrow-right"
                  id="activeTitileArrow"
                ></span>
              </Col>
            </Row>
          </Col>
          <Col>
            <Row>
              <Col xs={10} md={10} lg={8}>
                <Card id="firstCarOne">
                  <Row id="firstRoTwo">
                    <Col id="inActiveTab">
                      <span
                        className="bi bi-heart-pulse"
                        id="activeIcon"
                      ></span>
                    </Col>
                  </Row>
                  <Row>
                    <div>
                      <h6 style={{ color: "#3d5a95" }}>Medicals</h6>
                    </div>
                  </Row>
                </Card>
              </Col>
              <Col xs={2} md={2} lg={2}>
                <span
                  className="bi bi-arrow-right"
                  id="activeTitileArrow"
                ></span>
              </Col>
            </Row>
          </Col>
          <Col>
            <Row>
              <Col xs={10} md={10} lg={8}>
                <Card id="firstCarOne">
                  <Row id="firstRoTwo">
                    <Col id="inActiveTab">
                      <span
                        className="bi bi-pencil-square"
                        onClick={this.handleSubmitClick}
                        id="activeIcon"
                      ></span>
                    </Col>
                  </Row>
                  <Row>
                    <div>
                      <h6
                        style={{ color: "#3d5a95" }}
                        onClick={this.handleSubmitClick}
                      >
                        Nominee Details
                      </h6>
                    </div>
                  </Row>
                </Card>
              </Col>
              <Col xs={2} md={2} lg={2}></Col>
            </Row>
          </Col>
        </Row>
        <div>
          <Card>
            <Card.Body>
              <Row>
                <Col>
                  <br />
                  <h3>Optional AddOns</h3>
                  <Table className="table table-bordered">
                    <thead>
                      <tr>
                        <th scope="col">S No.</th>
                        <th scope="col">Code</th>
                        <th scope="col">Addon Name</th>
                        <th scope="col">Select</th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.optionaladdons.map((quote, index) => (
                        <tr key={index}>
                          <td style={{ width: "10px" }}>{index + 1}</td>
                          <td style={{ width: "250px" }}>
                            {quote.dummyThree} {quote.addONCode}
                          </td>
                          <td style={{ width: "600px" }}>{quote.addOn}</td>
                          <td style={{ width: "200px" }}>
                            {quote.dummyTwo ? (
                              <Form.Select
                                // name={`checkboxmonth-${quote.caresupremeaddons_Id}`}
                                // id={`checkboxmonth-${quote.caresupremeaddons_Id}`}
                                name={`select-${quote.caresupremeaddons_Id}`}
                                id={`select-${quote.caresupremeaddons_Id}`}
                                onChange={(e) =>
                                  this.handleOptionalSelectChange(
                                    quote.addONCode,
                                    quote.caresupremeaddons_Id,
                                    e.target.value
                                  )
                                }
                                aria-label="Default select example"
                                className="form-control"
                                //value={quote.checkboxmonth}
                                // value={quote.isMandatory || "Select"}
                                value={quote.selectedValue || "Select"}
                              >
                                <option>Select</option>
                                {quote.dummyTwo
                                  .split(",")
                                  .map((option, index) => (
                                    <option key={index} value={option.trim()}>
                                      {option.trim()}
                                    </option>
                                  ))}
                              </Form.Select>
                            ) : (
                              <input
                                type="checkbox"
                                id="consentCheckbox"
                                name="consentCheckbox"
                                onChange={(e) =>
                                  this.handleOptionalCheckboxChange(
                                    quote.addONCode,
                                    quote.caresupremeaddons_Id,
                                    !(quote.isMandatory === "yes"
                                      ? true
                                      : false)
                                  )
                                }
                                disabled={quote.isdisable === "yes"}
                              />
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </Col>
              </Row>
            </Card.Body>
            <div className="row">
              <div className="col" style={{ float: "right" }}>
                <Button
                  id="getQuotes4"
                  onClick={this.handleSubmitnextClick}
                  type="submit"
                  style={{ float: "right" }}
                >
                  Submit
                </Button>
              </div>
            </div>
            <br />
          </Card>
          <br />
        </div>
        <br />
        <div>
          <Card style={{ width: "18rem" }}>
            <Card.Body>
              <Card.Title>Updated Premium</Card.Title>
              <Card.Text>
                Premium: ₹
                {this.state.updatepremium
                  ? this.state.updatepremium.toLocaleString("en-IN")
                  : "Loading..."}
              </Card.Text>
              {/* Debug info - remove in production */}
              <small className="text-muted">
                Plan:{" "}
                {sessionStorage.getItem("selectedPlanName") || "Not selected"}
              </small>
            </Card.Body>
          </Card>
        </div>
        <br />
        <div className="row">
          <div className="col">
            <Button
              id="getQuotes4"
              onClick={this.handleSubmitClick}
              type="submit"
              style={{ float: "left" }}
            >
              Back
            </Button>
          </div>
          <div className="col" style={{ float: "right" }}>
            <Button
              id="getQuotes4"
              onClick={this.handleSubmitnextoneClick}
              type="submit"
              style={{ float: "right" }}
              disabled={this.stateisProposalDisabled}
            >
              Next
            </Button>
          </div>
        </div>
      </div>
    );
  }
}
